import cn from 'classnames'
import React, { useContext } from 'react'

import { SiteDataContext } from '../../components'

const PricingTab = ({ children, text, extraText }) => {
  const { isTextRtl } = useContext(SiteDataContext)
  return (
    <div className={cn('c-pricing-tab', { 'c-pricing-tab--rtl': isTextRtl })}>
      <p className="c-pricing-tab__text c-pricing-tab__text--small">
        {text} {extraText && <span>{extraText}</span>}
      </p>
      <div className="c-pricing-tab__grid">{children}</div>
    </div>
  )
}

export default PricingTab
